import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const IssueInProgressIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0" />
      <path d="M8 2.75a5.25 5.25 0 0 1 0 10.5v-2.5a2.75 2.75 0 0 0 0-5.5Z" />
    </CustomIcon>
  )
}
